import { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

// * All these class names were pulled from the typography styleguide that is zeplin

export default css`
  h1,
  h2,
  h3 {
    font-family: ${themeGet('fonts.noir')};
    color: ${themeGet('colors.main-text')};
    font-weight: ${themeGet('fontWeights.medium')};
    letter-spacing: -0.25px;

    a,
    span,
    p {
      font-weight: inherit;
      font-size: inherit;
      color: inherit;
    }
  }

  h1 {
    font-size: 1.5rem;
    line-height: 130%;
  }

  h2 {
    font-size: 1.375rem;
    line-height: 130%;
  }

  h3 {
    font-size: 1.25rem;
    line-height: 1.5rem;
  }

  h2,
  h3 {
    font-weight: ${themeGet('fontWeights.medium')};
  }

  .sr-only {
    clip: rect(0px, 0px, 0px, 0px);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  .sm-gap {
    margin-bottom: 0.5rem;
  }

  .lg-gap {
    margin-bottom: 1rem;
  }

  .xlg-gap {
    margin-bottom: 1.5rem;
  }

  p,
  span {
    font-family: ${themeGet('fonts.noir')};
    font-weight: ${themeGet('fontWeights.normal')};
    color: ${themeGet('colors.main-text')};
    letter-spacing: 0px;
    font-size: 1rem;
    line-height: 150%;

    &.large {
      font-size: 18px;
      line-height: 24px;
    }

    &.pts-text-large {
      font-size: 36px;
      line-height: 42px;
      font-weight: ${themeGet('fontWeights.medium')};
    }

    &.small {
      font-size: 14px;
      line-height: 22px;
    }

    /* Disclaimer / Product Description */
    &.tiny {
      font-size: 10px;
      line-height: 16px;
      color: ${themeGet('colors.white')};
    }

    &.label {
      font-size: 14px;
      line-height: 32px;
    }

    &.lg {
      font-size: 20px;
      line-height: 150%;
    }

    &.md {
      font-size: 18px;
      line-height: 150%;
    }

    &.xs {
      font-size: 14px;
      line-height: 150%;
    }

    a {
      font-size: inherit;
    }

    &.esso-red {
      font-size: inherit;
      font-weight: inherit;
      color: ${themeGet('colors.esso-red')};
    }

    &.white {
      font-size: inherit;
      font-weight: inherit;
      color: ${themeGet('colors.white')};
    }
  }

  a {
    color: ${themeGet('colors.main-text', 'black')};
    font-weight: ${themeGet('fontWeights.normal')};
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: normal;

    span {
      color: inherit;
      font-size: inherit;
      font-weight: inherit;
      line-height: inherit;
      letter-spacing: inherit;
    }
  }

  li {
    font-family: ${themeGet('fonts.noir')};
    color: ${themeGet('colors.main-text')};
  }

  // Adding text for screen readers to reference footnotes at bottom of the page
  sup {
    span {
      font-size: 1rem;
      font-weight: ${themeGet('fontWeights.normal')};
      clip: rect(0 0 0 0);
      clip-path: inset(50%);
      height: 1px;
      overflow: hidden;
      position: absolute;
      white-space: nowrap;
      width: 1px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    h1 {
      font-size: 2.5rem;
      line-height: 130%;
    }

    h2 {
      font-size: 2.25rem;
      line-height: 130%;
    }

    h3 {
      font-size: 2rem;
      line-height: 130%;
    }

    p,
    span {
      &.tiny {
        font-size: 12px;
        line-height: 18px;
      }

      &.label {
        font-size: 16px;
        line-height: 32px;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    h1 {
      font-size: 2.5rem;
      line-height: 130%;
    }

    h2 {
      font-size: 2.25rem;
      line-height: 130%;
    }

    h3 {
      font-size: 2rem;
      line-height: 150%;
    }

    p,
    span {
      &.lg {
        font-size: 24px;
        line-height: 36px;
      }

      &.md {
        font-size: 20px;
        line-height: 30px;
      }
    }

    &.xxl {
      font-size: 4rem;
      line-height: 120%;
    }

    &.xl {
      font-size: 3.5rem;
      line-height: 120%;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    h1 {
      font-size: 2.5rem;
      line-height: 120%;
    }

    h2 {
      font-size: 2.25rem;
      line-height: 130%;
    }

    h3 {
      font-size: 2rem;
      line-height: 130%;
    }

    p,
    span {
      font-size: 1rem;
      line-height: 1.5rem;

      &.large {
        font-size: 21px;
        line-height: 28px;
      }

      &.pts-text-large {
        font-size: 40px;
        line-height: 48px;
      }

      &.small {
        font-size: 16px;
        line-height: 24px;
      }

      &.tiny {
        font-size: 10px;
        line-height: 16px;
      }

      &.label {
        font-size: 18px;
        line-height: 32px;
      }
    }
  }
`;
